// Whether the dashboard project list should render its skeleton.
//
// Extracted from HomePage so the truth table can be tested against the SHIPPED
// predicate rather than a copy of it in a test file. The rule it encodes is
// easy to get subtly wrong and invisible when it is.

import type { ProjectVisibility } from './VisibilitySwitch'

export interface ProjectListLoadingInputs {
  isTabsLoading: boolean
  /** react-query `isPending`: in flight OR held disabled awaiting team scope. */
  isPagePending: boolean
  hasPageData: boolean
  isPlaceholderData: boolean
  /** The visibility the rows currently on screen belong to. */
  renderedVisibility: ProjectVisibility
  /** The visibility the user has selected. */
  selectedVisibility: ProjectVisibility
}

export function isProjectListLoading(i: ProjectListLoadingInputs): boolean {
  // `keepPreviousData` is right for paging, sorting and search -- the same set
  // of projects, rearranged -- so holding the old rows avoids a flash.
  //
  // It is WRONG across the Private/Team switch: those sets are disjoint, so the
  // rows on screen are not a stale view of the answer, they are the OTHER
  // answer. Showing Private projects under a Team heading is worse than showing
  // nothing, so this is treated as a cold load.
  const isSwitchingVisibility = i.isPlaceholderData && i.renderedVisibility !== i.selectedVisibility

  // `isPagePending` rather than `isLoading`: the query is held disabled until
  // the flags snapshot and active team settle, and a disabled query reports
  // isLoading=false, which would drop the user into the empty state.
  // `hasPageData` keeps a placeholder-backed refetch from reading as cold.
  return i.isTabsLoading || (i.isPagePending && !i.hasPageData) || isSwitchingVisibility
}
